module.exports = __webpack_public_path__ + "img/thumbnail_CommonOstrich_m_normal.9ae6e306.png";